import { render, staticRenderFns } from "./JewelerAiBanner.vue?vue&type=template&id=99681fd2&scoped=true"
import script from "./JewelerAiBanner.vue?vue&type=script&lang=js"
export * from "./JewelerAiBanner.vue?vue&type=script&lang=js"
import style0 from "./JewelerAiBanner.vue?vue&type=style&index=0&id=99681fd2&prod&lang=scss&scoped=true"
import style1 from "./JewelerAiBanner.vue?vue&type=style&index=1&id=99681fd2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99681fd2",
  null
  
)

export default component.exports